/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';

import ModalWithActions from '../../ModalWithActions';
import WeatherSelector from '../../shared/atoms/Widget/WeatherSelector';

const SelectorWeatherWidgetModal = ({
  modalShow,
  onSenderModalHide,
  onSubmit,
  current,
  ...props
}) => {
  const formRef = useRef();
  const { t } = useTranslation();
  const [isValid, setIsValid] = useState(true);

  const validateForm = vals => {
    const errors = {};

    if (!vals.unit.length) errors.unit = t('validation.required');

    if (errors.unit) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }

    return errors;
  };

  return (
    <ModalWithActions
      show={modalShow}
      modalTitle={t('atoms.widget.selector.header_weather')}
      modalText=""
      action={() => formRef.current?.handleSubmit()}
      onHide={onSenderModalHide}
      btActionDisabled={!isValid}
      inputComponent={
        <Formik
          innerRef={formRef}
          initialValues={{
            unit: current?.unit || '',
          }}
          validateOnBlur
          validateOnChange
          validate={validateForm}
          enableReinitialize={false}
          onSubmit={onSubmit}
        >
          {formikProps => <WeatherSelector {...formikProps} {...props} />}
        </Formik>
      }
    />
  );
};

SelectorWeatherWidgetModal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  current: PropTypes.object.isRequired,
  onSenderModalHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SelectorWeatherWidgetModal;
